/**
* @name: xm-form-item
* @author: weiyong
* @date: 2023-05-21 17:58
* @description：xm-form-item
* @update: 2023-05-21 17:58
*/
<template>
  <div class="xm-form-item" :style="ctlSty">
    <div  class="ant-form-item-label w100b">
      <label :for="propKey" :class="props.required?'ant-form-item-required':''">
        <span class="xm-form-label-text" :title="props.label">{{props.label}}</span>
        <el-label-remark-tip :props="props"/>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-form-item",
});
</script>

<script lang="ts" setup>
import {initPxSty} from "@/main-page/hooks/useCtlStyle";
import ElLabelRemarkTip from "@/main-page-form/common/el-label-remark-tip.vue";

interface IProp{
  props:any,
  propKey:string,
}
const propsPage=withDefaults(defineProps<IProp>(),{
  props:{},
  propKey:''
});
const {elConfig,props,showLabel}: any = toRefs(propsPage);

const ctlSty=computed(()=>{
  let sty={};
  initPxSty(sty,"width",unref(props).labelWidth)
  return sty;
})
</script>

<style type="text/css" lang="less">

</style>
